import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useStyles = makeStyles({
  contentPadding: {
    padding: "56px 200px",
  },
  tab: {
    display: "flex",
    flexDirection: "column",
    gap: "56px",
  },
  emptyState: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "80px 0",
    gap: designTokens.spacing[3],
    color: designTokens.neutral[500],
    fontSize: designTokens.fontSize.base,
  },
  emptyStateTitle: {
    fontSize: designTokens.fontSize.lg,
    fontWeight: designTokens.fontWeight.semibold,
    color: designTokens.neutral[700],
  },
});
